/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Vehicle } from '../../models/vehicle';

export interface GetVehicle$Params {

/**
 * Id of a resource.
 */
  id: string;
}

export function getVehicle(http: HttpClient, rootUrl: string, params: GetVehicle$Params, context?: HttpContext): Observable<StrictHttpResponse<Vehicle>> {
  const rb = new RequestBuilder(rootUrl, getVehicle.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {"style":"simple","explode":false});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Vehicle>;
    })
  );
}

getVehicle.PATH = '/api/v1/vehicles/{id}';
